// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-7715605d] {\n  fill: #fff\n}\n.st15[data-v-7715605d] {\n  fill: #38cdfd\n}\n", ""]);
// Exports
module.exports = exports;
